/* jshint esversion: 6 */
document.addEventListener("DOMContentLoaded", function () {
   
    // is my menu sticky?
    function checkMenuIsSticky() {
        let scrolled_val = window.scrollY;
        let headerHeight = document.getElementById('header-nav').clientHeight;
            
        if(scrolled_val > headerHeight) {
            document.querySelector('header.sticky-top').classList.add('is-pinned');
        }
        if(scrolled_val == 0) { 
            document.querySelector('header.sticky-top').classList.remove('is-pinned');
        }
    }

    checkMenuIsSticky();

    window.addEventListener('scroll', () => {
        checkMenuIsSticky();
    });

});